import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "a1ff4OVqdNODJ8gxh//jVc/", "Hall", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Node, Label, v3, tween } from "cc";
import { E_ADEventType, E_AdType, E_EventType, E_GameState, E_MainLayerType, E_PlatformType } from "./common/EnumBase";
import { App } from "./common/manager/App";
var ccclass = _decorator.ccclass,
    property = _decorator.property;
var Hall = (_dec = ccclass('Hall'), _dec2 = property(Node), _dec3 = property(Label), _dec4 = property(Node), _dec5 = property(Node), _dec6 = property(Label), _dec7 = property(Node), _dec8 = property(Node), _dec9 = property(Node), _dec10 = property(Node), _dec11 = property(Label), _dec12 = property(Node), _dec13 = property(Node), _dec14 = property(Node), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Hall, _Component);

  function Hall() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "n_shopEntrance", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lbl_lv", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_prop", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_acceleration", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lblMag_price", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_adMag", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_buyMag", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_magnetism", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_maxMag", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lblAcc_price", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_adAcc", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_buyAcc", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "n_maxAcc", _descriptor13, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_price_mag", 0);

    _defineProperty(_assertThisInitialized(_this), "_price_acc", 0);

    return _this;
  }

  var _proto = Hall.prototype;

  _proto.onLoad = function onLoad() {
    App.CommonAmn.recordInitPos(this.n_shopEntrance);
  };

  _proto.start = function start() {
    this.addEventListenr();
    this.addBtnEvent();
    this.updateMagnetism();
    this.updateAcceleration();
    this.updateBtnState();
    this.handle_lvUp();
  };

  _proto.onDestroy = function onDestroy() {
    // GameCtr.I.removeEventListener();
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {
    //段位经验变化
    App.EventMgr.addEventLintener(E_EventType.Coin_Change, this.handle_conChange, this);
    App.EventMgr.addEventLintener(E_EventType.Lv_Up, this.handle_lvUp, this);
    App.AdEventMgr.addEventLintener(E_ADEventType.video_showOver, this.handle_adSucc, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
    App.AdEventMgr.removeEvent(this);
  };

  _proto.addBtnEvent = function addBtnEvent() {
    App.GameCtrl.addBtnEvent(this.node, this.btn_event.bind(this));
  };

  _proto.handle_conChange = function handle_conChange() {
    this.updateBtnState();
  };

  _proto.handle_lvUp = function handle_lvUp() {
    this.lbl_lv.string = "LEVEL  " + (App.DataMgr.tollgateLv + 1);
  };

  _proto.handle_adSucc = function handle_adSucc() {
    if (App.AdCtrl.type == E_AdType.Magnetism) {
      this.upMagnetism();
    } else if (App.AdCtrl.type == E_AdType.Acceleration) {
      this.upAcceleration();
    }

    this.updateBtnState();
  };

  _proto.upMagnetism = function upMagnetism() {
    App.DataMgr.magnetismLv += 1;
    this.updateMagnetism();
  };

  _proto.upAcceleration = function upAcceleration() {
    App.DataMgr.accelerateLv += 1;
    this.updateAcceleration();
  }
  /**更新吸铁石 */
  ;

  _proto.updateMagnetism = function updateMagnetism() {
    var _this$n_magnetism$get;

    var lbl_lv = (_this$n_magnetism$get = this.n_magnetism.getChildByName("a_lbl_lv")) === null || _this$n_magnetism$get === void 0 ? void 0 : _this$n_magnetism$get.getComponent(Label);
    var lbl_vCur = this.n_magnetism.getChildByName("a_lbl_vCur").getComponent(Label);
    var lv = App.DataMgr.magnetismLv;
    lbl_lv.string = "Level  " + (lv + 1);
    lbl_vCur.string = lv * 25 + 100 + "%";
    this.lblMag_price.string = 70 * (lv + 1) + "";
    this._price_mag = (lv + 1) * 70;
  }
  /**更新加速器 */
  ;

  _proto.updateAcceleration = function updateAcceleration() {
    var _this$n_acceleration$;

    var lbl_lv = (_this$n_acceleration$ = this.n_acceleration.getChildByName("a_lbl_lv")) === null || _this$n_acceleration$ === void 0 ? void 0 : _this$n_acceleration$.getComponent(Label);
    var lbl_vCur = this.n_acceleration.getChildByName("a_lbl_vCur").getComponent(Label);
    var lv = App.DataMgr.accelerateLv;
    lbl_lv.string = "Level  " + (lv + 1);
    lbl_vCur.string = lv * 25 + 100 + "%";
    this.lblAcc_price.string = 70 * (lv + 1) + "";
    this._price_acc = (lv + 1) * 70;
  };

  _proto.updateBtnState = function updateBtnState() {
    if (App.DataMgr.accelerateLv >= App.DataMgr.accelerateRange) {
      this.n_maxAcc.active = true;
      this.n_adAcc.active = false;
      this.n_buyAcc.active = false;
    } else {
      this.n_maxAcc.active = false;
      var isEnough_acc = App.DataMgr.coin >= this._price_acc;
      this.n_adAcc.active = !isEnough_acc;
      this.n_buyAcc.active = isEnough_acc;
    }

    if (App.DataMgr.magnetismLv >= App.DataMgr.magnetismRange) {
      this.n_maxMag.active = true;
      this.n_adMag.active = false;
      this.n_buyMag.active = false;
    } else {
      this.n_maxMag.active = false;
      var isEnough_mag = App.DataMgr.coin >= this._price_mag;
      this.n_adMag.active = !isEnough_mag;
      this.n_buyMag.active = isEnough_mag;
    }
  }
  /**按钮事件 */
  ;

  _proto.btn_event = function btn_event(btn) {
    var name = btn.node.name;

    switch (name) {
      case "a_n_adMag":
        if (App.DataMgr.magnetismLv >= App.DataMgr.magnetismRange) return;
        App.AdCtrl.type = E_AdType.Magnetism;

        if (App.AdCtrl.platformType == E_PlatformType.Normal) {
          this.handle_adSucc();
        } else {
          App.AdCtrl.showRewardedVideoAd();
        }

        break;

      case "a_n_buyMag":
        if (App.DataMgr.magnetismLv >= App.DataMgr.magnetismRange) return;

        if (App.DataMgr.coin >= this._price_mag) {
          App.DataMgr.coin -= this._price_mag;
          this.upMagnetism();
          this.updateBtnState();
        }

        break;

      case "a_n_adAcc":
        if (App.DataMgr.accelerateLv >= App.DataMgr.accelerateRange) return;
        App.AdCtrl.type = E_AdType.Acceleration;

        if (App.AdCtrl.platformType == E_PlatformType.Normal) {
          this.handle_adSucc();
        } else {
          App.AdCtrl.showRewardedVideoAd();
        }

        break;

      case "a_n_buyAcc":
        if (App.DataMgr.accelerateLv >= App.DataMgr.accelerateRange) return;

        if (App.DataMgr.coin >= this._price_acc) {
          App.DataMgr.coin -= this._price_acc;
          this.upAcceleration();
          this.updateBtnState();
        }

        break;

      case "a_n_shopEntrance":
        App.GameCtrl.isSwitch = true;
        App.EventMgr.handleEvent(E_EventType.Layer_Switch, E_MainLayerType.Shop);
        break;
    }
  };

  _proto.enter = function enter() {
    App.GameCtrl.gameState = E_GameState.PreBegin;
    this.node.active = true;
    this.n_magnetism.scale = v3(0, 0, 0);
    this.n_acceleration.scale = v3(0, 0, 0);
    tween(this.n_magnetism).to(0.5, {
      scale: v3(1, 1, 1)
    }, {
      easing: "backOut"
    }).start();
    tween(this.n_acceleration).delay(0.2).to(0.5, {
      scale: v3(1, 1, 1)
    }, {
      easing: "backOut"
    }).start();
    this.n_prop.active = App.DataMgr.tollgateLv > 0;
  };

  _proto.exit = function exit() {};

  _proto.update = function update(dt) {};

  return Hall;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "n_shopEntrance", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "lbl_lv", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "n_prop", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "n_acceleration", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "lblMag_price", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "n_adMag", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "n_buyMag", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "n_magnetism", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "n_maxMag", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "lblAcc_price", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "n_adAcc", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "n_buyAcc", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "n_maxAcc", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
export { Hall as default };

_cclegacy._RF.pop();